module.exports = __webpack_public_path__ + "img/kek-logo.a9f14705.svg";